import Box from "@material-ui/core/Box";
import { DialogProps } from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import React, { useContext, useEffect, useState } from "react";
import TestRequestApi from "../../../api/services/TestRequestApi";
import CustomButton from "../../../components/Button/CustomButton";
import CustomDialog from "../../../components/Dialog/CustomDialog";
import CustomTextField from "../../../components/Input/CustomTextField";
import ErrorSnackbarContext, { SnackbarVisibility } from "../../../contexts/ErrorSnackbarContext";
import { SubstrateSampleContext } from "../../../contexts/SubstrateSampleContext";
import useEnv from "../../../hooks/env";

interface SubstrateReuseDialogProps extends DialogProps {
  callback: (closeDialog: boolean, dialog: "reuse" | "duplicate") => void;
  onClose: () => void;
  action: "USE" | "DUPLICATE";
}

const SubstrateReuseDialog: React.FC<SubstrateReuseDialogProps> = (props) => {
  const { action, open, onClose, callback } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [isError, setIsError] = useState(false);
  const { handleHttpError, showSnackbar } = useContext(ErrorSnackbarContext);
  const { testRequest } = useContext(SubstrateSampleContext);
  const errorMessage = "Please enter an existing Substrate Sample ID";
  const { api } = useEnv();
  const testRequestApi = new TestRequestApi(api);

  const addSubstrateSample = (sampleId: number) => {
    const testRequestId = testRequest?.requestId;
    if (testRequestId && sampleId) {
      if (action === "USE") {
        return testRequestApi.addTestRequestSubstrateSample(testRequestId, sampleId);
      }
      // else action === "DUPLICATE"
      return testRequestApi.cloneThenAddSubstrateSampleToTestRequest(testRequestId, sampleId);
    }
    return Promise.reject(new Error("No test request id provided."));
  };

  const actionAsText = action.charAt(0) + action.slice(1).toLowerCase();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const substrateSampleId = parseInt(searchTerm, 10);
    addSubstrateSample(substrateSampleId)
      .then(() => {
        showSnackbar(`Substrate sample ${actionAsText.toLowerCase()}d`, "success");
        callback(true, action === "USE" ? "reuse" : "duplicate");
      })
      .catch((error) => {
        if (error?.response?.status === 404) {
          handleHttpError(error, SnackbarVisibility.HIDDEN);
          setIsError(true);
        } else {
          handleHttpError(error);
        }
      });
  };

  useEffect(() => {
    if (!open) {
      return () => {
        setIsError(false);
        setSearchTerm("");
      };
    }
  });

  return (
    <CustomDialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <h2>{actionAsText.toUpperCase()} EXISTING SUBSTRATE SAMPLE</h2>
      <form onSubmit={handleSubmit}>
        <Grid container justify="flex-start" direction="row" spacing={4}>
          <Grid item xs={12}>
            <CustomTextField
              autoFocus
              error={isError}
              fullWidth
              helperText={isError ? errorMessage : undefined}
              label="Sample ID"
              noSpinners
              onChange={(event): void => {
                setSearchTerm(event.target.value);
                if (isError) {
                  setIsError(false);
                }
              }}
              type="number"
              value={searchTerm}
            />
          </Grid>
          <Grid container item xs={12} justify="flex-end">
            <Box>
              <CustomButton disabled={!searchTerm} primary text={actionAsText} type="submit" />
            </Box>
          </Grid>
        </Grid>
      </form>
    </CustomDialog>
  );
};

export default SubstrateReuseDialog;
